import React from 'react'
import { connect } from 'react-redux'
import { home } from '../actions'
import { addSubscriber, updateSubscriber, deleteSubscriber } from '../actions/admin'
import EditForm from '../components/EditForm'
import { getSubscriber, getUser, getAvailablePstnNumbers } from '../selectors'

const EditView = ({ updateSubscriber, addSubscriber, ...rest}) => (
    <EditForm {...rest} save={ subscriber => rest.subscriber ? updateSubscriber(subscriber) : addSubscriber(subscriber) } />
)

const mapStateToProps = (state, { params, subscriber }) => {
    const usedNumbers = state.subscribers.map(s => s.did).filter(n => n)
    const props = { 
        user: getUser(state),
        config: state.config,
        availableNumbers: getAvailablePstnNumbers(state)
    }
    if (!subscriber && params.subscriberId) {
        props.subscriber = getSubscriber(state, params.subscriberId)
    }
    return props
}

export default connect(mapStateToProps, { home, updateSubscriber, addSubscriber, deleteSubscriber })(EditView)


// WEBPACK FOOTER //
// ./containers/EditView.jsx